import "@grapecity/wijmo.cultures/wijmo.culture.ja";
import "@grapecity/wijmo.styles/wijmo.css";
import "./App.css";
import { ConfirmDialog } from "./components/dialog/ConfirmDialog";
import { DialogRoot } from "./components/dialog/DialogRoot";
import { LayoutContainer } from "./components/Layout";
import "gestalt/dist/gestalt.css";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import { AssignPageContainer } from "./pages/assign/AssignPageContainer";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { appActions } from "./store/app.store";
import { persistor, store } from "./store/index.store";
import { systemActions } from "./store/system.store";
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import {
  BrowserCacheLocation,
  Configuration,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";
import { azureAdScopes } from "./util/msal";

// MSAL configuration
const configuration: Configuration = {
  auth: {
    clientId: "191b7ce3-077f-4206-a5dd-8e5b0bc22fe2",
    authority:
      "https://login.microsoftonline.com/c813ba55-9b7c-4f8b-9f91-e41d258e16ce",
    clientCapabilities: ["CP1"], // This lets the resource server know that this client can handle claim challenges.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
  },
  system: {
    /**
     * Below you can configure MSAL.js logs. For more information, visit:
     * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
     */
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};
export const msalInstance = new PublicClientApplication(configuration);
const authRequest = {
  scopes: azureAdScopes,
};

initializeIcons(/* optional base url */);

window.addEventListener("online", () => {
  store.dispatch(appActions.REDUCER_SET_IS_ONLINE(true));
});
window.addEventListener("offline", () => {
  store.dispatch(appActions.REDUCER_SET_IS_ONLINE(false));
});

// ブラウザのショートカットを無効化
// ctrl + D (68)
// ctrl + F (70)
// ctrl + S (83)
// https://code.i-harness.com/ja-jp/q/a7dbfa
document.addEventListener(
  "keydown",
  (e) => {
    // noinspection JSDeprecatedSymbols
    if (
      (e.keyCode === 68 || e.keyCode === 70 || e.keyCode === 83) &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
    }
  },
  false
);

const initializeApp = () => {
  store.dispatch(appActions.REDUCER_SET_IS_ONLINE(navigator.onLine));
  store.dispatch(systemActions.SYSTEM_INITIALIZE_APPLICATION());
};

class App extends React.Component<{}, {}> {
  render() {
    return (
      <MsalProvider instance={msalInstance}>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={authRequest}
        >
          <Provider store={store}>
            <PersistGate
              loading={null}
              persistor={persistor}
              // https://github.com/rt2zz/redux-persist/issues/573#issuecomment-345115669
              onBeforeLift={initializeApp}
            >
              <LayoutContainer>
                <AssignPageContainer />
              </LayoutContainer>
              <DialogRoot />
              <ConfirmDialog />
            </PersistGate>
          </Provider>
        </MsalAuthenticationTemplate>
        <UnauthenticatedTemplate>
          <p>ログインしてください。</p>
        </UnauthenticatedTemplate>
      </MsalProvider>
    );
  }
}

export default App;
